<script setup>
const staticURLImg = useRuntimeConfig().public.staticURLImg

// SEO
useSeoMeta({
    title: 'Custom GUI',
    ogTitle: 'Custom GUI',
    description: 'satYatunes creates custom UI for audio plugins',
    ogDescription: 'satYatunes creates custom UI for audio plugins',
})

/* useHead({
    link: [
        {
            rel: 'preload',
            as: 'image',
            href: staticURLImg + 'excs-smone.webp',
        },
    ],
}) */
</script>

<template>
    <v-row id="customgui" class="justify-center align-center slide-from-top">
        <v-col cols="12">
            <v-row class="mb-10 justify-center">
                <!-- <v-col cols="12" class="text-h4 text-md-h3 text-center font-weight-medium st-text-shadow">
                    Elevate Your Brand with Custom GUIs
                </v-col> -->
                <v-col cols="12" class="mt-4 text-center">
                    <app-section-header
                        :id="`elvtbrnd`"
                        :title="`Elevate Your Brand with Custom GUIs`"
                        :subtitle="``"
                    />
                </v-col>
                <v-col cols="11" class="st-card-text text-center">
                    A custom GUI, or skin, is more than just a logo slapped on an interface. It's a powerful marketing
                    tool that reflects your brand identity and enhances user experience. We specialize in creating
                    unique GUIs.
                </v-col>
            </v-row>
            <v-row class="justify-center bg-grey-darken-4 rounded st-box-shadow">
                <v-col cols="11" class="mt-16 text-center">
                    <v-icon color="light-blue-darken-2" size="48"> mdi-gift-open </v-icon>
                </v-col>
                <v-col cols="11" class="mb-4 st-header"> Bundle with Your Products </v-col>
                <v-col cols="11">
                    <div class="mb-6 st-card-text--justify">
                        Increase perceived value by offering a cohesive look and feel when users combine your products.
                        We've created custom skins for Bjulin and Swan Audio that they bundled with their soundsets, and
                        a Fishman-branded skin for KV331 Audio's SynthMaster One plugin, bundled with Fishman's Triple
                        Play.
                    </div>
                </v-col>
                <v-col cols="11" class="mb-16 fade-in-up">
                    <v-row>
                        <v-col cols="12" md="4" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `excs-bjulin.webp`"
                                class="rounded elevation-1"
                                alt="Theme based custom GUI for soundsets"
                            ></v-img>
                            <div class="text-caption">Bjulin bundled custom skins with their soundset</div>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `excs-smone.webp`"
                                class="rounded elevation-1"
                                alt="Custom GUI for loyal users"
                            ></v-img>
                            <div class="text-caption">
                                Fishman bundled SynthMaster One with a custom skin for their users
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + `excs-swan-audio.webp`"
                                class="rounded elevation-1"
                                alt="Custom GUIs for product bundle"
                            ></v-img>
                            <div class="text-caption">Swan Audio bundled theme based skins with their soundset</div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="justify-center bg-grey-lighten-3">
                <v-col cols="11" class="mt-16 text-center">
                    <v-icon color="green-darken-3" size="48"> mdi-desk </v-icon>
                </v-col>
                <v-col cols="11" class="mb-4 st-header"> Inspirational Workflow </v-col>
                <v-col cols="11">
                    <v-img
                        id="cardImg"
                        :src="staticURLImg + `excs-workflow.webp`"
                        class="rounded elevation-1"
                        alt="Spire custom GUI for inspiration"
                    ></v-img>
                </v-col>
                <v-col cols="11" class="mb-16 mt-4 st-card-text-grey-lt2 text-justify">
                    What if you love the synth but don't like the look? What if you want a look that inspires you? That
                    is exactly what Sterling Angel did with Spire. They wanted a custom UI designed for their specific
                    needs. They reached out to us and the Polar skin was born.
                </v-col>
            </v-row>
            <v-row class="justify-center bg-grey-darken-4 st-box-shadow rounded">
                <v-col cols="11" class="mt-16 text-center">
                    <v-icon color="amber-accent-4" size="48"> mdi-stamper </v-icon>
                </v-col>
                <v-col cols="11" class="mb-4 st-header"> Collaborate with a Brand </v-col>
                <v-col cols="11">
                    <v-img
                        id="cardImg"
                        :src="staticURLImg + `excs-burak-yeter.webp`"
                        class="rounded elevation-1"
                        alt="Burak Yeter edition Custom GUI for branding"
                    ></v-img>
                </v-col>
                <v-col cols="11" class="mb-16 mt-4 st-card-text--justify">
                    We collaborated with KV331 Audio to develop SynthMaster Burak Yeter Edition. Burak's favorite color
                    is Orange so we built the theme around that. Collaborating with a popular producer or artist is a
                    fantastic way to showcase your signature style.
                </v-col>
            </v-row>
            <v-row class="mt-6 justify-center">
                <v-col cols="10" md="5">
                    <v-card variant="flat" class="st-card bg-grey-darken-4 st-box-shadow">
                        <v-card-item class="text-center">
                            <v-icon color="deep-orange" size="48"> mdi-star-shooting </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Beyond Customization </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text--justify">
                            Looking to personalize an existing skin from our library? We offer licensing options for
                            many of our creations.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="10" md="5">
                    <v-card variant="flat" class="st-card bg-grey-darken-4 st-box-shadow">
                        <v-card-item class="text-center">
                            <v-icon color="deep-purple" size="48"> mdi-help-rhombus </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Ready for Special Edition? </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text--justify">
                            Contact us today! We'll customize a skin and develop a unique edition just for you.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" class="mt-6 mb-16 text-center">
                    <v-btn
                        text="Let's Collab"
                        to="/support"
                        size="x-large"
                        color="deep-orange-accent-4"
                        aria-label="Collaborate with satYatunes"
                    ></v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
